import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1239f324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "task-status_description" }

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { TaskParameter, TaskParameterTypeEnum } from '@/components';
import { TirPmTooltipElement } from 'tir-pm-tooltip-element';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-status',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
  /**Таблица на странице мониторинга по тикетам */
  monitoringTicketPage: { type: Boolean, default: false },
  /**Расположить статус в левой части таблицы */
  isStatusLeftBlock: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (!__props.isStatusLeftBlock)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(TaskCardItemWrapper), {
          element: __props.element,
          class: _normalizeClass({ 'task-status_block': __props.monitoringTicketPage })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TirPmTooltipElement), {
              isDisabled: !__props.task.Status.Description
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.task.Status.Description), 1)
              ]),
              default: _withCtx(() => [
                (__props.task.Status)
                  ? (_openBlock(), _createBlock(_unref(TaskParameter), {
                      key: 0,
                      preview: "",
                      type: _unref(TaskParameterTypeEnum).Status,
                      data: __props.task.Status,
                      hideRemove: ""
                    }, null, 8, ["type", "data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["isDisabled"])
          ]),
          _: 1
        }, 8, ["element", "class"])
      ]))
    : _createCommentVNode("", true)
}
}

})